<template>
    <div>
        <!-- 标题-->
        <el-breadcrumb separator="/" class="bread">
            <el-breadcrumb-item>微页面管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!--创建活动 按钮-->
        <!--@click="getData" icon="search":loading="loading"-->
        <el-button type="primary" @click="toCreate()">
            创建微页面
        </el-button>
        <!--搜索活动-->

        <div style="margin-top: 10px">
            <el-select class="m-1" v-model="kioskNo" placeholder="机器编号" @change="getData()">
                <!--<el-option label="T1-A101" value="T1-A101" v-show="this.getcookie('storeId')=='store001'">T1-A101</el-option>-->
                <el-option label="K1-A112" value="K1-A112" v-show="this.getcookie('storeId')=='store001'">K1-A112</el-option>
                <el-option label="K1-A113" value="K1-A113" v-show="this.getcookie('storeId')=='store001'">K1-A113</el-option>
                <el-option label="X2-A179" value="X2-A179" v-show="this.getcookie('storeId')=='0001'">X2-A179</el-option>
                <el-option label="X2-A173" value="X2-A173" v-show="this.getcookie('storeId')=='0001'">X2-A173</el-option>
            </el-select>
            <el-input v-model="pageName" placeholder="页面名称" style="width: 20%"></el-input>
            <el-button type="primary" class="" @click="secrehData()">
                查询
            </el-button>
        </div>
        <!-- 表格分页-->
        <div class="block">
            <el-table :data="tableData" border style="width: 100%;">
                <el-table-column prop="pageName" label="页面名称">
                    <template scope="scope">
                        {{scope.row.pageName}}&nbsp&nbsp<span v-if="scope.row.isHomePage=='1'" style="background-color: #3388ff;color: #fff; font-size: 12px;">店铺主页</span>
                    </template>
                </el-table-column>
                <el-table-column prop="deviceId" label="设备编号"></el-table-column>

                <el-table-column prop="createTime" label="创建时间" :formatter="formatter" sortable>
                </el-table-column>
                <el-table-column label="操作">
                    <template scope="scope">
                        <el-button size="small" type="text" @click="setHomePage(scope.row)" v-if="scope.row.isHomePage=='0'">
                            设为主页
                        </el-button>
                        <el-button size="small" type="text" @click="goToEditer(scope.row)">
                            编辑
                        </el-button>
                        <el-button size="small" type="text" @click="copyPage(scope.row)">
                            复制
                        </el-button>
                        <el-button size="small" type="text" @click="deleteHomePage(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-chahange="handleSizeChange"
                    :current-page="currentpage"
                    :page-count="pagesCount"
                    :page-sizes="pagesizes"
                    :page-size="pagesize"
                    :total="pagesCount"
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    // import action from "../../../store/actions"
    import moment from 'moment'

    export default {
        name: "ActivityManager",
        data() {
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                name: '',
                loading: false,
                isable: false,
                dialogVisible: false,
                tenantId:'',//租户ID
                kioskNo:'',
                pageName:'',
                token:'123123123'
            }
        },
        created() {
            this.tenantId = this.getcookie("storeId");
            this.getData();
        },
        methods: {
            secrehData(){
                this.currentpage=1;
                this.activeNum=0;
                this.getData();
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pagesize = val
                this.activeNum = (val * this.currentpage) - val;
                this.endNum = (val * this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val) {
                this.currentpage = val;
                this.activeNum = (this.pagesize * val) - this.pagesize
                this.endNum = (this.pagesize * val)
                this.getData();
            },
            getData() {
                //数据请求
                this.loading = true
                //异步请求
                this.$http.get(this.homePageHost+this.findHomePageListURL + "?active="
                    + this.activeNum + "&len=" + this.pagesize+"&deviceId="+this.kioskNo+"&pageName="+this.pageName+"&tenantId="+this.tenantId+"&Token="+this.token)
                    .then(response => {
                        console.log(response.body)
                        if (response.status === 200) {
                            this.pagesCount = response.body.total;
                            this.tableData = response.body.data;
                            this.loading = false;
                            console.log( this.pagesCount);
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            /*编辑页面跳转*/
            toCreate(row){
                this.savecookie("button", "addHomePage");
                this.$router.push({
                    path: "addHomePage"
                });
            },
            goToEditer(row){
                console.log("编辑按钮："+row.id)
                this.savecookie("button", "modifyHomePage");
                this.$router.push({
                    path: "modifyHomePage",query:{id:row.id,}
                });
            },
            /*设为主页*/
            setHomePage(row){
                this.loading = true
                var params = {tenantId:this.tenantId,id:row.id,Token:this.token};
                //异步请求
                this.$http.post(this.homePageHost+this.setHomePageUrl,params)
                    .then(response => {
                        if (response.body.Code == "200") {
                            this.$message({showClose: true, message: '设置成功', type: 'success'});
                            this.getData();
                        }else if (response.body.Code == "501205") {
                            this.$message({
                                showClose: true,
                                message: response.body.Meta,
                                type: 'error'
                            });
                        }else if (response.body.Code == "500") {
                            console.log("500")
                            this.$message({
                                showClose: true,
                                message: response.body.Meta,
                                type: 'error'
                            });
                        }
                    },function(response){
                        console.log("fail")
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })
            },
            /*删除活动*/
            deleteHomePage(row){
                this.$confirm('你确定要删除这条数据么？删除是不可恢复的', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //数据请求
                    this.loading = true
                    var params = {tenantId:this.tenantId,id:row.id,Token:this.token};
                    //异步请求
                    this.$http.post(this.homePageHost+this.delPageUrl,params)
                        .then(response => {
                            if (response.status === 200) {
                                if (response.body.Code == "200") {
                                    this.$message({showClose: true, message: '删除成功', type: 'success'});
                                    this.getData();
                                }else if (response.body.Code != "500"&&response.body.Code != "200") {
                                    this.$message({
                                        showClose: true,
                                        message: response.body.Meta,
                                        type: 'error'
                                    });
                                }else if (response.body.Code == "500") {
                                    this.$message({
                                        showClose: true,
                                        message: '系统异常',
                                        type: 'error'
                                    });
                                }
                            }
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'
                            });
                        })
                })
            },
            /*复制页面*/
            copyPage(row){
                //数据请求
                this.loading = true
                var params = {tenantId:this.tenantId,id:row.id,Token:this.token};
                //异步请求
                this.$http.post(this.homePageHost+this.copyPageUrl,params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == "200") {
                                this.$message({showClose: true, message: '复制成功', type: 'success'});
                                this.getData();
                            }else if (response.body.Code != "500"&&response.body.Code != "200") {
                                this.$message({
                                    showClose: true,
                                    message: response.body.Meta,
                                    type: 'error'
                                });
                            }else if (response.body.Code == "500") {
                                console.log("500")
                                this.$message({
                                    showClose: true,
                                    message: '系统异常',
                                    type: 'error'
                                });
                            }
                        }
                    },function(response){
                        console.log("fail")
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })

            },
            /*日期转换时间戳*/
            timeCycle(time) {
                var date = new Date(time.replace(/-/g, '/'));
                return date.getTime();
            },
            formatter(row, column) {
                var d = new Date(row.createTime);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// homePageManager.vue?10bd7297